import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { ModelRow } from "@mcleod/core";
import { DriverEventSlideout } from "../../DriverEventSlideout";

export class RowActionDriverEvent extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonDriverEvent;
    }

    override getButtonId(): string {
        return "buttonDriverEvent";
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["driver1_id", "driver1_name", "driver1_manager", "driver1_manager_name"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        const modelRow = selectedRows[0];
        if (modelRow.isNull("driver1_id")) {
            this.addReason(reasonMap, "missing_driver", "Missing driver");
        }
    }

    override execute(props: PlanningTableRowActionProps) {
        const modelRow = props.selectedRows[0]?.data as ModelRow;
        if (!modelRow) {
            return;
        }

        const driverEventSlideout = new DriverEventSlideout();
        driverEventSlideout.showSlideout({
            equipmentId: modelRow?.getString("driver1_id"),
            equipmentEditable: true,
            equipmentName: modelRow?.getString("driver1_name"),
            driverMgrId: modelRow?.getString("driver1_manager"),
            driverMgrName: modelRow?.getString("driver1_manager_name")
        });
    }
}
